import { Button, Modal, Slider, TextField, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import React, { useEffect, useState, useRef } from "react";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { FaMapMarkerAlt } from "react-icons/fa";
import {
  Brush,
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Legend
} from "recharts";
import ModelRankingTable from './ModelRankingTable';
import html2canvas from "html2canvas";
import "./leftbar.css";
import { format } from "date-fns";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { saveAs } from "file-saver";
import "jspdf-autotable";
import Papa from "papaparse";
import jsPDF from "jspdf";

const Anomalylog = ({
  selectedMarker,
  imdatalogs,
  setIsLoading,
  handleCloseAnModal,
  handleZoomInImDatalogs,
  sortConfig,
  setSortConfig,
  getImDatalogs,
  handleZoomOutImDatalogs,
  resetZoomImDatalogs,
  zoomLevelImDatalogs,
  handleZoomImDatalogs,
  visibleDataImDatalogs,
  sortedImDatalogs,
  setIsAnModalOpen,
  setIsMultiColAnModalOpen,
  formatDate,
  setimDatalogs,
}) => {

  const [dataLimitImDatalogs, setDataLimitImDatalogs] = useState(
    visibleDataImDatalogs.length
  ); // Default to all data

  // Apply the data limit to the visible data
  const handleDataLimitChangeImDatalogs = (event) => {
    setDataLimitImDatalogs(parseInt(event.target.value));
  };

  // Apply the data limit to the visible data
  const filteredDataImDatalogs = visibleDataImDatalogs.slice(
    -dataLimitImDatalogs
  );

  const [originalValue, setOriginalValue] = useState(null);
  const [isLoadingOriginal, setIsLoadingOriginal] = useState(false);
  const [originalError, setOriginalError] = useState(null);

  const fetchOriginalValue = async (dataPoint) => {
    if (!dataPoint) return;
    setIsLoadingOriginal(true);
    setOriginalError(null);
    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/get-original-value', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          wellId: dataPoint.wellId,
          mTm: dataPoint.mTm
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to fetch original value');
      }

      const data = await response.json();
      if (data.success) {
        setOriginalValue(data.originalValue.wtr);
      } else {
        throw new Error('Failed to retrieve original value');
      }
    } catch (error) {
      console.error('Error fetching original value:', error);
      setOriginalError(error.message);
    } finally {
      setIsLoadingOriginal(false);
    }
  };

  const [isConfirmRevertModalOpen, setIsConfirmRevertModalOpen] = useState(false);
  const [selectedDataPoint, setSelectedDataPoint] = useState(null);
  const [isRevertModalOpen, setIsRevertModalOpen] = useState(false);

  // Handler for clicking an anomaly-corrected point
  const handleAnomalyPointClick = (dataPoint) => {
    setSelectedDataPoint(dataPoint);
    setIsRevertModalOpen(true);
    fetchOriginalValue(dataPoint);
  };

  // Closing the revert modal
  const handleCloseRevertModal = () => {
    setIsRevertModalOpen(false);
    setSelectedDataPoint(null);
  };

  const handleRevertAnomaly = () => {
    setIsRevertModalOpen(false);
    setIsConfirmRevertModalOpen(true);
  };

  // Handling the final confirmation
  const handleConfirmRevert = async () => {
    if (!selectedDataPoint) return;

    setIsLoading(true);

    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/revert-anomaly-correction', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          wellId: selectedMarker.wellId,
          mTm: selectedDataPoint.mTm,
          versionNumber: selectedVersionAnom
        })
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      // Refreshing the data after reversion
      const updatedData = await getImDatalogs(selectedMarker.wellId);

      // Closing all modals
      setIsConfirmRevertModalOpen(false);
      setSelectedDataPoint(null);

      // Showing success message
      alert('Data point successfully reverted to original value');
    } catch (error) {
      console.error('Error reverting anomaly correction:', error);
      alert(`Failed to revert anomaly correction: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // Closing the confirmation modal
  const handleCloseConfirmRevertModal = () => {
    setIsConfirmRevertModalOpen(false);
  };

  const [showMinDateModal, setShowMinDateModal] = useState(false);
  const handleEndDateChange = (event) => {
    const newEndDate = event.target.value;
    // Only perform validation if both dates are selected
    if (startDate && newEndDate) {
      const start = new Date(startDate);
      const end = new Date(newEndDate);

      // Calculate difference in years
      const diffInMs = end - start;
      const msInYear = 1000 * 60 * 60 * 24 * 365.25; // Account for leap years
      const diffInYears = diffInMs / msInYear;

      if (diffInYears < 2) {
        // If less than 2 years, show the modal and don't update the end date
        setShowMinDateModal(true);
        return;
      }
    }
    // If validation passes or not enough info to validate, update the end date
    setEndDate(newEndDate);
  };
  const handleCloseMinDateModal = () => {
    setShowMinDateModal(false);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  // Fetching versions on component mount or when selectedMarker changes
  useEffect(() => {
    if (selectedMarker && selectedMarker.wellId) {
      fetchVersions(selectedMarker.wellId); // Fetching versions when the wellId is available
    }
  }, [selectedMarker]);

  const [weights, setWeights] = useState({
    weight_lstm: 1,
    weight_bilstm: 1,
    weight_arima: 1,
    weight_sarima: 1,
    weight_iter: 1,
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
  };

  const handleWeightChange = (event) => {
    const { name, value } = event.target;
    if (isNaN(value)) {
      alert("Please enter a numerical value");
      return;
    }
    setWeights((prevWeights) => ({
      ...prevWeights,
      [name]: value,
    }));
  };

  const [Rate, setRate] = useState("");
  const handleRateChange = (event) => {
    setRate(event.target.value);
  };

  const [option, setOption] = useState("overall"); // Initialize with the string "overall"

  const handleOption = (event, newOption) => {
    if (newOption !== null) {
      setOption(newOption);
    }
  };

  const [missingDataRate, setMissingDataRate] = useState(null);
  const [showMissingRate, setShowMissingRate] = useState(false);

  const fetchMissingDataRate = async () => {
    if (!selectedMarker || !startDate || !endDate) {
      alert("Please specify both start and end dates");
      return;
    }

    if (startDate > endDate) {
      alert("Start date cannot be after end date");
      return;
    }

    // setIsLoading(true);

    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/missing-data-rate/${selectedMarker.wellId}/${startDate}/${endDate}`, {
        method: "GET"
      });

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log("Missing data rate response:", data);

      setMissingDataRate(data.missingRate);
      setShowMissingRate(true);

    } catch (error) {
      console.error("Error fetching missing data rate:", error);
      alert(`Failed to fetch missing data rate: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  const [earliestDate, setEarliestDate] = useState("");
  const [latestDate, setLatestDate] = useState("");
  useEffect(() => {
    const fetchDateRange = async () => {
      try {
        const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}/date-range`);
        const data = await response.json();
        if (response.ok) {
          setEarliestDate(data.earliest);
          setLatestDate(data.latest);
        } else {
          console.error(data.message || "Failed to fetch date range.");
        }
      } catch (err) {
        console.error("Error fetching date range:", err);
      }
    };
    fetchDateRange();
  }, [selectedMarker]);


  const [selectedMetric, setSelectedMetric] = useState("wtr"); // Default to Water Level

  const CustomDotAnomaly = (props) => {
    const { cx, cy, payload, onClick } = props;

    // Handler for clicking on an anomaly-corrected point
    const handleClick = () => {
      if (payload.is_anomaly_corrected) {
        onClick(payload);
      }
    };

    // If this is an anomaly-corrected point
    if (payload.is_anomaly_corrected) {
      return (
        <>
          {/* Original value (green dot) */}
          {/* {payload.originalValue && (
            <circle
              cx={cx}
              cy={cy - (payload.wtr - payload.originalValue) * 30} // Offset based on difference
              r={5}
              stroke="green"
              strokeWidth={2}
              fill="green"
            />
          )} */}
          {/* Line connecting original and corrected values */}
          {/* {payload.originalValue && (
            <line
              x1={cx}
              y1={cy}
              x2={cx}
              y2={cy - (payload.wtr - payload.originalValue) * 30}
              stroke="green"
              strokeWidth={1.5}
              strokeDasharray="3,3"
            />
          )} */}
          {/* Corrected value (orange dot) */}
          <circle
            cx={cx}
            cy={cy}
            r={5}
            stroke="orange"
            strokeWidth={2}
            fill="orange"
            style={{ cursor: 'pointer' }}
            onClick={handleClick}
          />
        </>
      );
    }

    // Normal data point
    return (
      <circle
        cx={cx}
        cy={cy}
        r={5}
        fill="black"
      />
    );
  };


  const [progress, setProgress] = useState(0);

  const [AnRate, setAnRate] = useState("");
  const handleAnRateChange = (event) => {
    setAnRate(event.target.value);
  };

  const handleSort = (key) => {
    const newDirection = sortConfig[key].direction === "asc" ? "desc" : "asc";
    setSortConfig({
      ...sortConfig,
      [key]: { direction: newDirection },
    });
  };

  // const imdownloadAsCSV = () => {
  //   const csv = Papa.unparse(imdatalogs);
  //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  //   // add version name to filename
  //   const filename = selectedVersionAnom === "0" ? "raw_datalogs.csv" : `anomaly_datalogs_version_${selectedVersionAnom}.csv`;

  //   saveAs(blob, filename);
  // };

  const imdownloadAsCSV = () => {
      const options = {
        fields: ["Measurement Time", "Water Level", "Is Anomaly Corrected?"],
        quotes: true 
      };
  
     
      const customData = imdatalogs.map(row => [
        row.mTm,           
        row.wtr,             
        row.is_anomaly_corrected ? "Yes" : "No"  
      ]);
  
      // Create CSV with custom field names
      const csv = Papa.unparse({
        fields: options.fields,
        data: customData
      }, options);
  
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const filename = selectedVersionAnom === "0" ? "raw_datalogs.csv" : `anomaly_datalogs_version_${selectedVersionAnom}.csv`;
    saveAs(blob, filename);
    };

  const imdownloadAsPDF = () => {
    const doc = new jsPDF();
    const tableData = imdatalogs.map((datalog) => [
      datalog.mTm,
      datalog.wtr,
      datalog.is_anomaly_corrected ? "Yes" : "No",
    ]);

    doc.text("Datalogs", 14, 10);
    doc.autoTable({
      head: [
        [
          "Measurement Time",
          "Water Level",
          "Is Anomaly Corrected?",
        ],
      ],
      body: tableData,
    });
    const filename = selectedVersionAnom === "0" ? `raw_datalogs_of_well_${selectedMarker.wellId}.pdf` : `anomaly_datalogs_of_well_${selectedMarker.wellId}_version_${selectedVersionAnom}.pdf`;

    doc.save(filename);
  };

  const handleAnomalyCorrection = async (retryCount = 0, maxRetries = 3) => {
    if (selectedMarker) {
      setIsLoading(true);

      // Validating inputs
      if (!AnRate) {
        alert("Please enter a deviation percentage.");
        setIsLoading(false);
        return;
      }

      // Checking if date range is valid when provided
      if (startDate && endDate && startDate > endDate) {
        alert("Start date cannot be after end date.");
        setIsLoading(false);
        return;
      }

      // Checking if weights are all zero
      const allZeroWeights =
        weights.weight_lstm === 0 &&
        weights.weight_bilstm === 0 &&
        weights.weight_arima === 0 &&
        weights.weight_sarima === 0;

      if (allZeroWeights) {
        alert("Please set at least one model weight above zero");
        setIsLoading(false);
        return;
      }

      try {
        let url = `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs-anomaly/${selectedMarker.wellId}/${AnRate}/${selectedVersion}`;

        // Adding date range parameters if provided
        if (startDate && endDate) {
          url += `/${startDate}/${endDate}`;
        } else {
          // Using default dates if not provided
          const defaultStartDate = '1977-01-03';
          const defaultEndDate = '1980-01-24';
          url += `/${defaultStartDate}/${defaultEndDate}`;
        }

        const res = await fetch(url, {
          method: "POST",
          headers: {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${localStorage.getItem('token')}`
          },
          body: JSON.stringify({
            weight_lstm: weights.weight_lstm,
            weight_bilstm: weights.weight_bilstm,
            weight_arima: weights.weight_arima,
            weight_sarima: weights.weight_sarima
          })
        });

        if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

        const anomalyData = await res.json();
        console.log("Received anomaly detection results:", anomalyData);

        // Fetching updated data
        const updatedData = await getImDatalogs(selectedMarker.wellId);
        setIsAnModalOpen(true);
      } catch (err) {
        console.error("Error during anomaly detection:", err);
        if (retryCount < maxRetries) {
          console.warn(`Retrying... Attempt ${retryCount + 1}`);
          await handleAnomalyCorrection(retryCount + 1, maxRetries);
        } else {
          console.error("Max retries reached. Aborting.");
          alert(`Failed to process anomaly detection: ${err.message}`);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };



  // const handleAnomalyCorrection = async (retryCount = 0, maxRetries = 3) => {
  //   if (selectedMarker) {
  //     setIsLoading(true);

  //     // Validating inputs
  //     if (!AnRate) {
  //       alert("Please enter a deviation percentage.");
  //       setIsLoading(false);
  //       return;
  //     }

  //     // Checking if date range is valid when provided
  //     if (startDate && endDate && startDate > endDate) {
  //       alert("Start date cannot be after end date.");
  //       setIsLoading(false);
  //       return;
  //     }

  //     // Checking if weights are all zero
  //     const allZeroWeights =
  //       weights.weight_lstm === 0 &&
  //       weights.weight_bilstm === 0 &&
  //       weights.weight_arima === 0 &&
  //       weights.weight_sarima === 0;

  //     if (allZeroWeights) {
  //       alert("Please set at least one model weight above zero");
  //       setIsLoading(false);
  //       return;
  //     }

  //     try {
  //       let url = `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs-anomaly/${selectedMarker.wellId}/${AnRate}/${selectedVersion}`;

  //       // Adding date range parameters if provided
  //       if (startDate && endDate) {
  //         url += `/${startDate}/${endDate}`;
  //       } else {
  //         // Using default dates if not provided
  //         const defaultStartDate = '1977-01-03';
  //         const defaultEndDate = '1980-01-24';
  //         url += `/${defaultStartDate}/${defaultEndDate}`;
  //       }

  //       // Create an AbortController to handle the timeout
  //       const controller = new AbortController();
  //       const timeoutId = setTimeout(() => controller.abort(), 600000); // 5-minute timeout (600,000 ms)

  //       try {
  //         const res = await fetch(url, {
  //           method: "POST",
  //           headers: {
  //             'Content-Type': 'application/json',
  //             "Authorization": `Bearer ${localStorage.getItem('token')}`
  //           },
  //           body: JSON.stringify({
  //             weight_lstm: weights.weight_lstm,
  //             weight_bilstm: weights.weight_bilstm,
  //             weight_arima: weights.weight_arima,
  //             weight_sarima: weights.weight_sarima
  //           }),
  //           signal: controller.signal // Add the abort signal
  //         });

  //         // Clear the timeout since the request completed
  //         clearTimeout(timeoutId);

  //         if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

  //         const anomalyData = await res.json();
  //         console.log("Received anomaly detection results:", anomalyData);

  //         // Fetching updated data
  //         const updatedData = await getImDatalogs(selectedMarker.wellId);
  //         setIsAnModalOpen(true);
  //       } catch (fetchError) {
  //         clearTimeout(timeoutId); // Make sure to clear the timeout
  //         // Re-throw the error to be caught by the outer try-catch
  //         throw fetchError;
  //       }
  //     } catch (err) {
  //       console.error("Error during anomaly detection:", err);

  //       // Check if it was a timeout error
  //       if (err.name === 'AbortError') {
  //         console.error("Request timed out after 5 minutes");
  //         alert("The request took too long and timed out. The process may still be running on the server.");
  //       } else if (retryCount < maxRetries) {
  //         console.warn(`Retrying... Attempt ${retryCount + 1}`);
  //         await handleAnomalyCorrection(retryCount + 1, maxRetries);
  //       } else {
  //         console.error("Max retries reached. Aborting.");
  //         alert(`Failed to process anomaly detection: ${err.message}`);
  //       }
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  // };


  // const handleAnomalyCorrection = async () => {
  //   if (selectedMarker) {
  //     setIsLoading(true);

  //     // Validating inputs
  //     if (!AnRate) {
  //       alert("Please enter a deviation percentage.");
  //       setIsLoading(false);
  //       return;
  //     }

  //     // Checking if date range is valid when provided
  //     if (startDate && endDate && startDate > endDate) {
  //       alert("Start date cannot be after end date.");
  //       setIsLoading(false);
  //       return;
  //     }

  //     // Checking if weights are all zero
  //     const allZeroWeights =
  //       weights.weight_lstm === 0 &&
  //       weights.weight_bilstm === 0 &&
  //       weights.weight_arima === 0 &&
  //       weights.weight_sarima === 0;

  //     if (allZeroWeights) {
  //       alert("Please set at least one model weight above zero");
  //       setIsLoading(false);
  //       return;
  //     }

  //     try {
  //       let url = `https://warpo-dashboard.cse.buet.ac.bd/api/send-datalogs-anomaly/${selectedMarker.wellId}/${AnRate}/${selectedVersion}`;

  //       // Adding date range parameters if provided
  //       if (startDate && endDate) {
  //         url += `/${startDate}/${endDate}`;
  //       } else {
  //         // Using default dates if not provided
  //         const defaultStartDate = '1977-01-03';
  //         const defaultEndDate = '1980-01-24';
  //         url += `/${defaultStartDate}/${defaultEndDate}`;
  //       }

  //       const res = await fetch(url, {
  //         method: "POST",
  //         headers: {
  //           'Content-Type': 'application/json',
  //           "Authorization": `Bearer ${localStorage.getItem('token')}`
  //         },
  //         body: JSON.stringify({
  //           weight_lstm: weights.weight_lstm,
  //           weight_bilstm: weights.weight_bilstm,
  //           weight_arima: weights.weight_arima,
  //           weight_sarima: weights.weight_sarima
  //         })
  //       });

  //       if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

  //       const anomalyData = await res.json();
  //       console.log("Received anomaly detection results:", anomalyData);

  //       // Fetching updated data
  //       const updatedData = await getImDatalogs(selectedMarker.wellId);
  //       setIsAnModalOpen(true);
  //     } catch (err) {
  //       console.error("Error during anomaly detection:", err);
  //       alert(`Failed to process anomaly detection: ${err.message}`);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   }
  // };


  const handleShowAnDatalog = () => {
    setIsLoading(true);
    setProgress(0);
    const duration = 5000; // Total duration in milliseconds (5 seconds)
    const intervalTime = 50; // Interval time in milliseconds
    const increment = 100 / (duration / intervalTime); // Calculate increment value

    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            getImDatalogs(selectedMarker.wellId);
            setIsAnModalOpen(true);
            setIsLoading(false);
          }, 2000); // Keep the screen for an additional 1 second after progress completes
          return 100;
        }
        return prevProgress + increment;
      });
    }, intervalTime);
  };

  // Fetching versions based on selected wellId
  const fetchVersions = async (wellId) => {
    try {
      const response = await fetch(`https://warpo-dashboard.cse.buet.ac.bd/api/datalogs_versions/${wellId}`);
      const data = await response.json();

      if (response.ok) {
        const impData = data.filter(item => item.imp_or_anom === 'imp');
        const anomData = data.filter(item => item.imp_or_anom === 'anom');

        console.log(impData)

        setVersions(impData);
        setVersionsanom(anomData);

        // Check if anomaly correction versions exist
        if (anomData.length > 0) {
          // Get the latest anomaly version (assuming the last one in the array is the most recent)
          const latestAnomVersion = anomData[anomData.length - 1];

          // Set the selected version in the dropdown
          setSelectedVersionAnom(latestAnomVersion.version_number);

          // Fetch and load the data for this version
          handleLoadAnomVersion(latestAnomVersion.version_number);
        }
      } else {
        console.error("Error fetching versions:", data.error);
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
  };

  const handleMultiColAnomaly = () => {
    
    setIsAnModalOpen(false);
    setIsMultiColAnModalOpen(true)
            
  };

  
  // const handleLoadAnomVersion = async (versionNumber) => {
  //   try {
  //     // Fetching version-specific data
  //     const response = await fetch(
  //       `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
  //     );
  //     const data = await response.json();

  //     if (response.ok) {
  //       setTableData(data);
  //       setimDatalogs(data);

  //       // Reset zoom and visualization settings
  //       resetZoomImDatalogs();
  //       setDataLimitImDatalogs(data.length);
  //     } else {
  //       console.error("Error fetching anomaly corrected data:", data.error);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  const handleLoadAnomVersion = async (versionNumber) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (!response.ok) {
        console.error("Error fetching anomaly corrected data:", data.error);
        return;
      }

      // ✅ Fetch original values for anomaly-corrected points
      const enhancedData = await fetchOriginalValues(data, selectedMarker.wellId);

      setTableData(enhancedData);
      setimDatalogs(enhancedData);

      console.log("ENHANCED DATA: ", enhancedData)

      // Reset zoom and visualization settings
      resetZoomImDatalogs();
      setDataLimitImDatalogs(enhancedData.length);

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  // State to store modal open state and version details
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [versionDetails, setVersionDetails] = useState(null);
  const [versions, setVersions] = useState([]); // Store versions data from backend
  const [versionsanom, setVersionsanom] = useState([]); // Store versions data from backend
  const [selectedVersionAnom, setSelectedVersionAnom] = useState("Null"); // Selected version number
  const [selectedVersion, setSelectedVersion] = useState("0"); // Selected version number
  const [tableData, setTableData] = useState([]); // Store the fetched data for the selected version

 
  

  const handleVersionChange = async (event) => {
    const versionNumber = event.target.value;
    setSelectedVersion(versionNumber);

    // try {
    //   if (versionNumber === "0") {
    //     // Fetching raw datalogs without any anomaly correction
    //     const response = await fetch(
    //       `https://warpo-dashboard.cse.buet.ac.bd/api/datalogs/${selectedMarker.wellId}`
    //     );
    //     const data = await response.json();

    //     if (response.ok) {
    //       // Adding is_anomaly_corrected: false to all records
    //       const rawData = data.map(item => ({
    //         ...item,
    //         is_anomaly_corrected: false
    //       }));

    //       setTableData(rawData);
    //       setimDatalogs(rawData);

    //       // Reset zoom and visualization settings
    //       resetZoomImDatalogs();
    //       setDataLimitImDatalogs(rawData.length);
    //     } else {
    //       console.error("Error fetching raw data:", data.error);
    //       alert("Error fetching raw data");
    //     }
    //   } else {
    //     // Fetching version-specific data
    //     const response = await fetch(
    //       `https://warpo-dashboard.cse.buet.ac.bd/api/imdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
    //     );
    //     const data = await response.json();

    //     if (response.ok) {
    //       setTableData(data);
    //       setimDatalogs(data);

    //       // Reset zoom and visualization settings
    //       resetZoomImDatalogs();
    //       setDataLimitImDatalogs(data.length);
    //     } else {
    //       console.error("Error fetching imputed data:", data.error);
    //       alert("Error fetching data for this version");
    //     }
    //   }
    // } catch (error) {
    //   console.error("Error fetching data:", error);
    //   alert("Failed to fetch data for this version");
    // }
  };

  // const handleVersionChangeAnom = async (event) => {
  //   const versionNumber = event.target.value;
  //   setSelectedVersionAnom(versionNumber);

  //   try {
  //     // Fetching version-specific data
  //     const response = await fetch(
  //       `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
  //     );
  //     const data = await response.json();

  //     if (response.ok) {
  //       setTableData(data);
  //       setimDatalogs(data);

  //       // Reset zoom and visualization settings
  //       resetZoomImDatalogs();
  //       setDataLimitImDatalogs(data.length);
  //     } else {
  //       console.error("Error fetching anomaly corrected data:", data.error);
  //       alert("Error fetching data for this version");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //     alert("Failed to fetch data for this version");
  //   }
  // };

  const handleVersionChangeAnom = async (event) => {
    const versionNumber = event.target.value;
    setSelectedVersionAnom(versionNumber);

    try {
      // Fetching version-specific anomaly-corrected data
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/anomdatalogs_version/${selectedMarker.wellId}/${versionNumber}`
      );
      const data = await response.json();

      if (!response.ok) {
        console.error("Error fetching anomaly corrected data:", data.error);
        alert("Error fetching data for this version");
        return;
      }

      // ✅ Fetch original values for anomaly-corrected points
      const enhancedData = await fetchOriginalValues(data, selectedMarker.wellId);

      setTableData(enhancedData);
      setimDatalogs(enhancedData);

      // Reset zoom and visualization settings
      resetZoomImDatalogs();
      setDataLimitImDatalogs(enhancedData.length);
      
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("Failed to fetch data for this version");
    }
  };

  const handleDetailsButtonClick = () => {
    if (selectedVersion) {
      fetchVersionDetails(selectedMarker.wellId, selectedVersion); // Fetching details for the selected version
    }
  };

  const fetchVersionDetails = async () => {
    try {
      // Handling raw data (version 0) case
      if (selectedVersion === "0") {
        setVersionDetails({
          wellId: selectedMarker.wellId,
          version_number: "0",
          update_time: new Date().toISOString(),
          comments: "Raw data without any corrections",
          name: "System",
          email: "system@example.com",
          designation: "System",
          contact_no: "-",
          start_date: "",
          end_date: ""
        });
        setIsModalOpen(true);
        return;
      }

      // Handling regular version details
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${selectedMarker.wellId}/${selectedVersion}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'imp_or_anom': 'imp'
          }
        }
      );
      const data = await response.json();

      if (response.ok) {
        setVersionDetails(data);
        setIsModalOpen(true);
      } else {
        console.error("Error fetching version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching data from backend:", error);
    }
  };


  const handleDetailsButtonClickAnom = () => {
    if (selectedVersionAnom) {
      fetchVersionDetailsAnom(selectedMarker.wellId, selectedVersionAnom);
    }
  };

  const fetchVersionDetailsAnom = async (wellId, version) => {
    try {
      const response = await fetch(
        `https://warpo-dashboard.cse.buet.ac.bd/api/get-version-details/${wellId}/${version}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'imp_or_anom': 'anom'
          }
        }
      );
      const data = await response.json();

      if (response.ok) {
        setVersionDetails(data);
        setIsModalOpen(true);
      } else {
        console.error("Error fetching anomaly version details:", data.error);
      }
    } catch (error) {
      console.error("Error fetching anomaly data from backend:", error);
    }
  };

  const chartRef = useRef();
  const handleDownload = () => {
    if (chartRef.current) {
      html2canvas(chartRef.current).then((canvas) => {
        const link = document.createElement("a");
        link.download = "AnomalyDatalog.png";
        link.href = canvas.toDataURL();
        link.click();
      });
    }
  };

  // const originalValueFetchedRef = useRef(false);


  const fetchOriginalValues = async (dataPoints, wellId) => {
    // Only process anomaly-corrected points
    const anomalyPoints = dataPoints.filter(point => point.is_anomaly_corrected);

    if (anomalyPoints.length === 0) return dataPoints;

    // if (originalValueFetchedRef.current) return dataPoints; 

    try {
      const response = await fetch('https://warpo-dashboard.cse.buet.ac.bd/api/get-multiple-original-values', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          wellId: wellId,
          measurementTimes: anomalyPoints.map(point => point.mTm)
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to fetch original values');
      }

      const data = await response.json();
      if (data.success) {
        // Create a map of original values by measurement time
        const originalValuesMap = new Map();
        data.originalValues.forEach(val => {
          originalValuesMap.set(val.mTm, val.wtr);
        });

        // originalValueFetchedRef.current = true;

        // Merge original values into the dataset
        return dataPoints.map(point => {
          if (point.is_anomaly_corrected && originalValuesMap.has(point.mTm)) {
            return {
              ...point,
              originalValue: originalValuesMap.get(point.mTm)
            };
          }
          return point;
        });
      }

      return dataPoints;
    } catch (error) {
      console.error('Error fetching original values:', error);
      return dataPoints;
    }
  };

  // useEffect(() => {
  //   const loadOriginalValues = async () => {
  //     if (imdatalogs && imdatalogs.length > 0 && selectedMarker && selectedMarker.wellId) {
  //       // Check if any points are anomaly corrected
  //       const hasAnomalyPoints = imdatalogs.some(point => point.is_anomaly_corrected);

  //       if (hasAnomalyPoints) {
  //         // Fetch and add original values
  //         const enhancedData = await fetchOriginalValues(imdatalogs, selectedMarker.wellId);
  //         console.log(enhancedData)
  //         setimDatalogs(enhancedData);
  //       }
  //     }
  //   };

  //   loadOriginalValues();
  // }, [imdatalogs, selectedMarker]);


  return (
    <div className="modal">
      <div className="modal-overlay" />
      <div className="modal-row">
        <div className="modal-content left-content">
          <div className="input-group">
            <div className="left-content-wrapper" style={{ display: "flex", flexDirection: "column", gap: "10px" }}>

              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                <div className="anomaly-header" style={{ textAlign: "left" }}>
                  <h2 style={{ marginBottom: "0px", marginTop: '0px', color: "red" }}>Anomaly Correction using Groundwater Level Data</h2>
                </div>
                <div className="multiple-col-anomaly" style={{ textAlign: "right" }}>
                  <button
                    variant="contained"
                    onClick={handleMultiColAnomaly}
                    style={{
                      height: "60px",
                      backgroundColor: "#ff1111",
                      color: "white",
                      textTransform: "none",
                      fontSize: "20px",
                      width: "250px"
                    }}
                  >
                    Anomaly Correction using Secondary Data
                  </button>
                </div>
              </div>
              <div className="well-info-container" style={{ marginRight: "20px" }}>
                
                <h2 style={{ marginBottom: "0px", marginTop: 0 }}>{selectedMarker.wellId}</h2>
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
                </p>
              </div>

              <div className="date-range-display">
                <p style={{ textAlign: "center", margin: "4px 0" }}>
                  <strong>Earliest Date:</strong> {earliestDate ? new Date(earliestDate).toLocaleDateString() : 'Loading...'} &nbsp; | &nbsp;
                  <strong>Latest Date:</strong> {latestDate ? new Date(latestDate).toLocaleDateString() : 'Loading...'}
                </p>
              </div>

              <Modal
                open={showMinDateModal}
                onClose={handleCloseMinDateModal}
                aria-labelledby="min-date-modal-title"
              >
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  width: 400,
                  backgroundColor: '#fff',
                  border: '2px solid #000',
                  boxShadow: 24,
                  padding: '15px 20px',
                  borderRadius: '8px'
                }}>
                  <Typography id="min-date-modal-title" variant="h6" component="h2" style={{ color: '#d32f2f', marginBottom: '10px' }}>
                    Insufficient Date Range
                  </Typography>
                  <Typography style={{ marginBottom: '15px', color: '#333' }}>
                    Please select an end date that is at least 2 years after the start date for proper anomaly correction analysis.
                  </Typography>
                  <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                      onClick={handleCloseMinDateModal}
                      variant="contained"
                      style={{ backgroundColor: '#d32f2f', color: 'white' }}
                    >
                      Close
                    </Button>
                  </div>
                </div>
              </Modal>

              <div className="date-range-container" style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "4px" }}>
                <div className="date-inputs" style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "flex-end" }}>
                  <div className="date-field-container">
                    <label htmlFor="start-date" style={{ color: "#85126e", marginBottom: "2px", display: "block" }}>
                      Start Date
                    </label>
                    <input
                      id="start-date"
                      type="date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="date-input-field"
                      style={{
                        padding: "6px", 
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "180px" 
                      }}
                    />
                  </div>
                  <div className="date-field-container">
                    <label htmlFor="end-date" style={{ color: "#85126e", marginBottom: "2px", display: "block" }}>
                      End Date
                    </label>
                    <input
                      id="end-date"
                      type="date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="date-input-field"
                      style={{
                        padding: "6px", 
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        color: "#85126e",
                        width: "180px" 
                      }}
                    />
                  </div>
                </div>

                {/* Add Missing Data Rate Button centered */}
                <div style={{ marginTop: "0px", display: "flex", justifyContent: "center" }}>
                  <Button
                    variant="contained"
                    onClick={fetchMissingDataRate}
                    style={{
                      height: "40px",
                      backgroundColor: "#4a148c",
                      color: "white",
                      textTransform: "none",
                      fontSize: "16px",
                      width: "250px"
                    }}
                  >
                    Show Missing Data Rate
                  </Button>
                </div>

                {/* Static Missing Data Rate Message */}
                {showMissingRate && missingDataRate !== null && (
                  <div
                    style={{
                      marginTop: "8px", /* Reduced margin */
                      padding: "6px", /* Reduced padding */
                      backgroundColor: "#f0f0f0",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      width: "90%",
                      textAlign: "center"
                    }}
                  >
                    <p style={{ margin: 0, fontWeight: "bold", textAlign: "center", fontSize: "14px" }}>
                      Missing Data Rate for Selected Period: <span style={{ color: "#d32f2f" }}>{missingDataRate.toFixed(2)}%</span>
                    </p>
                  </div>
                )}
              </div>

              <div style={{ display: "flex", justifyContent: "center", alignItems: "flex-end", gap: "10px", width: "100%" }}>
                <div className="missing-container">
                  <h3 style={{ margin: "5px 0", fontSize: "15px" }}>Artificial Missing Rate:</h3>
                  <TextField
                    variant="outlined"
                    value={Rate}
                    onChange={handleRateChange}
                    className="rate-text-field"
                    InputLabelProps={{
                      style: { color: "#85126e" },
                    }}
                    InputProps={{
                      style: { color: "#85126e" },
                    }}
                    sx={{ height: "48px" }}
                  />
                </div>
                <div className="toggle-group-container">
                  <h3 style={{ margin: "5px 0", fontSize: "15px" }}>Season-Based Type:</h3>
                  <ToggleButtonGroup
                    value={option}
                    exclusive
                    onChange={handleOption}
                    aria-label="Choose one"
                    className="toggle-button-group"
                    sx={{
                      height: "48px", 
                      width: "230px", 
                      display: "flex"
                    }}
                  >
                    <ToggleButton
                      value="overall"
                      aria-label="overall"
                      sx={{
                        flex: "1 1 50%",
                        borderRadius: option === "overall" ? undefined : "4px 0 0 4px"
                      }}
                    >
                      Overall
                    </ToggleButton>
                    <ToggleButton
                      value="peak"
                      aria-label="peak"
                      sx={{
                        flex: "1 1 50%",
                        borderRadius: option === "peak" ? undefined : "0 4px 4px 0"
                      }}
                    >
                      Peak - Off-Peak
                    </ToggleButton>
                  </ToggleButtonGroup>
                </div>
              </div>

              <div style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                margin: "10px 0" /* Reduced margin */
              }}>
                <ModelRankingTable
                  selectedMarker={selectedMarker}
                  Rate={Rate}
                  option={option}
                  startDate={startDate}
                  endDate={endDate}
                  imp_or_anom="anom"
                />
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px', 
                marginBottom: '5px', 
                width: '100%'
              }}>
                <FormControl variant="outlined" style={{ width: '600px' }}> {/* Reduced width */}
                  <InputLabel id="version-label">Select Version of Imputation</InputLabel>
                  <Select
                    labelId="version-label"
                    value={selectedVersion}
                    onChange={handleVersionChange}
                    label="Select Version"
                    fullWidth
                    size="small" 
                  >
                    {/* Add Raw Data as version 0 */}
                    <MenuItem key="raw-data" value="0">
                      Version 0 - Raw Data
                    </MenuItem>
                    {versions.map((version) => (
                      <MenuItem key={version.version_number} value={version.version_number}>
                        {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd--MM--yyyy HH:mm:ss')}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDetailsButtonClick}
                  size="small" 
                >
                  Details
                </Button>
              </div>

              {/* Version details modal*/}
              <Modal open={isModalOpen} onClose={handleCloseModal}>
                <div
                  style={{
                    position: 'absolute',
                    top: '53%',
                    left: '74%',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: 'cyan',
                    color: 'black',
                    padding: '15px', 
                    borderRadius: '8px',
                    minWidth: '380px', 
                  }}
                >
                  <Typography variant="h6" style={{ fontSize: "16px", margin: "0 0 8px 0" }}>Version Details</Typography>

                  {versionDetails ? (
                    <div style={{ fontSize: "14px" }}> 
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Well ID:</strong> {versionDetails.wellId}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Version Number:</strong> {versionDetails.version_number}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Update Time:</strong> {formatDate(versionDetails.update_time)}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        <strong>Date Range:</strong>  {formatDate(versionDetails.start_date, 'd MMM yyyy')} to{' '}
                        {formatDate(versionDetails.end_date, 'd MMM yyyy')}
                      </p>

                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Name:</strong> {versionDetails.name}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Designation:</strong> {versionDetails.designation}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Email:</strong> {versionDetails.email}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Contact No:</strong> {versionDetails.contact_no}</p>
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}><strong>Comments:</strong> {versionDetails.comments}</p>
                    </div>
                  ) : (
                    <p style={{ fontSize: "14px" }}>Loading...</p>
                  )}

                  {/* Close Button */}
                  <Button
                    onClick={handleCloseModal}
                    style={{ backgroundColor: 'red', color: 'white', width: '90px', height: '32px', fontSize: '13px', marginTop: '6px' }}
                  >
                    Close
                  </Button>
                </div>
              </Modal>

              <div className="model-weights" style={{
                textAlign: "center",
                marginTop: "5px",
                width: "100%",  // Make sure it takes full width of parent
                display: "flex",
                flexDirection: "column",
                marginLeft: "-30px",
                alignItems: "center"  // Center children on cross axis
              }}>
                <h3 style={{ margin: "5px 0", fontSize: "15px" }}>Model Weights:</h3>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "8px",
                  justifyContent: "center",  // Center items horizontally
                  maxWidth: "480px",  // Control the maximum width of the container
                  margin: "0 auto"    // Auto margins for horizontal centering
                }}>
                  <TextField
                    label="LSTM"
                    variant="outlined"
                    name="weight_lstm"
                    value={weights.weight_lstm}
                    onChange={handleWeightChange}
                    className="weight-input"
                    size="small"
                    style={{ width: "110px" }}
                  />
                  <TextField
                    label="BiLSTM"
                    variant="outlined"
                    name="weight_bilstm"
                    value={weights.weight_bilstm}
                    onChange={handleWeightChange}
                    className="weight-input"
                    size="small"
                    style={{ width: "110px" }}
                  />
                  <TextField
                    label="ARIMA"
                    variant="outlined"
                    name="weight_arima"
                    value={weights.weight_arima}
                    onChange={handleWeightChange}
                    className="weight-input"
                    size="small"
                    style={{ width: "110px" }}
                  />
                  <TextField
                    label="SARIMA"
                    variant="outlined"
                    name="weight_sarima"
                    value={weights.weight_sarima}
                    onChange={handleWeightChange}
                    className="weight-input"
                    size="small"
                    style={{ width: "110px" }}
                  />
                </div>
              </div>

              <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "3px", 
                width: "280px", 
                maxWidth: "500px",
                margin: "5px auto"
              }}>

                <div className="form-group" style={{
                  width: "100%",
                  textAlign: "center"
                }}>
                  <h3 style={{ marginBottom: "5px", fontSize: "15px" }}>Maximum Deviation Percentage</h3>
                  <TextField
                    label="Percentage"
                    variant="outlined"
                    value={AnRate}
                    onChange={handleAnRateChange}
                    className="rate-text-field"
                    fullWidth
                    size="small" 
                    InputLabelProps={{
                      style: { color: "#85126e" },
                    }}
                    InputProps={{
                      style: { color: "#85126e" },
                    }}
                  />
                </div>

                <div className="action-buttons" style={{
                  marginTop: "8px", 
                  width: "100%",
                  display: "flex",
                  justifyContent: "center"
                }}>
                  <Button
                    variant="contained"
                    onClick={handleAnomalyCorrection}
                    className="button submit-button"
                    size="medium" 
                    style={{ height: "36px" }} 
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-content right-content" style={{
          display: "flex",
          flexDirection: "column", 
          justifyContent: "flex-start", 
          alignItems: "center",
          height: "100vh",
          textAlign: "center",
          padding: "10px", 
          gap: "5px" 
        }}>
          <div style={{ flexShrink: 0}}>
          <div className="button-group" style={{ marginBottom: "0px", marginTop: "35px" }}>
            <Button
              variant="contained"
              onClick={imdownloadAsCSV}
              className="blue-button"
              size="small" 
              style={{ margin: "0 2px" }} 
            >
              Download as CSV
            </Button>
            <Button
              variant="contained"
              onClick={imdownloadAsPDF}
              className="green-button"
              size="small" 
              style={{ margin: "0 2px" }} 
            >
              Download as PDF
            </Button>
            <Button
              variant="contained"
              onClick={handleCloseAnModal}
              className="red-button"
              textAlign="right"
              size="small" 
              style={{ margin: "0 2px" }} 
            >
              Close Window
            </Button>
          </div>
          <div className="well-info-container" style={{marginTop: "5px", marginBottom: "10px" }}>
            <h2 style={{ margin: 0, fontSize: "18px", marginTop: "10px" }}>{selectedMarker.wellId}</h2>
            <p style={{ marginBottom: '5px', fontSize: "14px", textAlign: "center" }}>
              <FaMapMarkerAlt style={{ marginRight: "8px", color: "red" }} /> {selectedMarker.union_}, {selectedMarker.upazilla}, {selectedMarker.district}, {selectedMarker.division}
            </p>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px', justifyContent: 'center' }}>
            <FormControl variant="outlined" style={{ width: '600px' }}> 
              <InputLabel id="version-label">Select Version of Anomaly Correction</InputLabel>
              <Select
                labelId="version-label"
                value={selectedVersionAnom}
                onChange={handleVersionChangeAnom}
                label="Select Version"
                fullWidth
                size="small" 
              >
                {versionsanom.map((version) => (
                  <MenuItem key={version.version_number} value={version.version_number}>
                    {`[${version.measurement_parameters.join(', ')}] Version ${version.version_number} - ${format(new Date(version.update_time), 'dd--MM--yyyy HH:mm:ss')}`}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              color="primary"
                onClick={handleDetailsButtonClickAnom}
              size="small"
            >
              Details
            </Button>
          </div>
          
          <div style={{ flex: 1, overflowY: 'auto',padding: '10px' , marginLeft: '10px', marginRight: '10px' }}>
          <div className="graph-container" style={{ marginBottom: '5px', width: "100%" }}>
            <div className="button-group" style={{ display: "flex", gap: "3px", justifyContent: "center", marginBottom: "5px" }}>
              <Button
                variant="contained"
                onClick={resetZoomImDatalogs}
                className="zoom-button"
                size="small"
              >
                Reset Zoom
              </Button>
              <Button
                variant="contained"
                onClick={handleDownload}
                className="zoom-button"
                size="small"
              >
                Save Image
              </Button>
            </div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px", 
                width: "100%",
                marginBottom: "5px" /* Added margin */
              }}
            >
              <Slider
                value={zoomLevelImDatalogs}
                onChange={handleZoomImDatalogs}
                aria-labelledby="zoom-slider"
                min={0} // Default is 0 (No Zoom)
                max={100} // Maximum is 100 (Fully Zoomed In)
                step={5}
                valueLabelDisplay="auto"
                style={{ flex: 1 }} // Makes the slider take available space
                size="small" 
              />
              <h3 style={{ minWidth: "40px", margin: 0, fontSize: "14px" }}>
                {zoomLevelImDatalogs}%
              </h3>
            </div>

            <div className="filter-container" style={{ display: "flex", alignItems: "center", gap: "10px", justifyContent: "center", marginBottom: "5px" }}>
              <h3 className="filter-label">Filter Data: </h3>
              <FormControl
                variant="outlined"
                size="small"
                className="filter-dropdown"
              >
                <InputLabel>Data Points</InputLabel>
                <Select
                  value={dataLimitImDatalogs}
                  onChange={handleDataLimitChangeImDatalogs}
                  label="Data Points"
                >
                  <MenuItem value={10}>Last 10</MenuItem>
                  <MenuItem value={50}>Last 50</MenuItem>
                  <MenuItem value={100}>Last 100</MenuItem>
                  <MenuItem value={visibleDataImDatalogs.length}>
                    All
                  </MenuItem>
                </Select>
              </FormControl>
            </div>


            {/*Revert confirmation modal */}
            <Modal open={isRevertModalOpen} onClose={handleCloseRevertModal}>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'white',
                  color: 'black',
                  padding: '15px', 
                  borderRadius: '8px',
                  minWidth: '380px', 
                }}
              >
                <Typography variant="h6" style={{ fontSize: "16px", marginBottom: "10px" }}>Anomaly Correction</Typography>

                {selectedDataPoint && (
                  <div style={{ fontSize: "14px" }}>
                    <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                      <strong>Time:</strong> {formatDate(selectedDataPoint.mTm)}
                    </p>
                    <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                      <strong>Anomaly Corrected Value:</strong> {selectedDataPoint.wtr} meter
                    </p>
                    {isLoadingOriginal ? (
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>Loading original value...</p>
                    ) : originalError ? (
                      <p style={{ color: 'red', fontSize: '14px', margin: '4px 0' }}>
                        Error loading original value: {originalError}
                      </p>
                    ) : originalValue !== null ? (
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        <strong>Original Value:</strong> {originalValue} meter
                      </p>
                    ) : (
                      <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                        Original value is null
                      </p>
                    )}
                    <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                      If you want to revert this anomaly corrected data to the original value, please click the "Revert to Original" button below.
                    </p>
                  </div>
                )}

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
                  <Button
                    onClick={handleCloseRevertModal}
                    style={{ backgroundColor: 'grey', color: 'white', height: '32px', fontSize: '13px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleRevertAnomaly}
                    style={{ backgroundColor: 'red', color: 'white', height: '32px', fontSize: '13px' }}
                    disabled={isLoadingOriginal}
                  >
                    Revert to Original
                  </Button>
                </div>
              </div>
            </Modal>

            {/* Second confirmation modal */}
            <Modal open={isConfirmRevertModalOpen} onClose={handleCloseConfirmRevertModal}>
              <div
                style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  backgroundColor: 'white',
                  color: 'black',
                  padding: '15px',
                  borderRadius: '8px',
                  minWidth: '380px', 
                }}
              >
                <Typography variant="h6" style={{ fontSize: "16px", marginBottom: "10px" }}>Confirm Reversion</Typography>

                {selectedDataPoint && (
                  <div style={{ fontSize: "14px" }}>
                    <p style={{ color: 'black', fontSize: '14px', margin: '4px 0' }}>
                      This action cannot be undone. The data point will be restored to its original value.
                    </p>
                    <p style={{ color: 'black', fontSize: '14px', margin: '4px 0', fontWeight: 'bold' }}>
                      Are you sure you want to revert this anomaly corrected value?
                    </p>
                  </div>
                )}

                {/* Action buttons */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
                  <Button
                    onClick={handleCloseConfirmRevertModal}
                    style={{ backgroundColor: 'grey', color: 'white', height: '32px', fontSize: '13px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleConfirmRevert}
                    style={{ backgroundColor: 'red', color: 'white', height: '32px', fontSize: '13px' }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </Modal>
            
            <div ref={chartRef}>
                <ResponsiveContainer width="100%" height={320}>
                  <LineChart
                    data={filteredDataImDatalogs.length > 0 ? filteredDataImDatalogs : []}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                      dataKey="mTm"
                      tickFormatter={(tick) => new Date(tick).toLocaleDateString()}
                      label={{
                        value: "Measurement Time",
                        position: "insideBottom",
                        offset: 0,
                        dy: 1,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <YAxis
                      domain={[0, 12]}
                      label={{
                        value: "Water Level(meter)",
                        angle: -90,
                        position: "insideLeft",
                        dy: 60,
                        fontSize: 12
                      }}
                      tick={{ fontSize: 10 }}
                    />
                    <Tooltip
                      contentStyle={{ color: "#fff" }}
                      labelFormatter={(value) => `Time: ${formatDate(value)}`}
                      formatter={(value, name) => {
                        if (name === "originalValue") {
                          return [`${value}`, "Original Value"];
                        }
                        return [`${value}`, `${name.toUpperCase()}`];
                      }}
                    />

                    {/* Add a line for original values */}
                    <Line
                      type="monotone"
                      dataKey="originalValue"
                      stroke="purple"  // Green color for original values
                      strokeWidth={1.5}
                      dot={{ r: 5, fill: "purple", stroke: "purple", strokeWidth: 1 }}
                      activeDot={false}  // ⛔ disable misleading hover marker
                      name="originalValue"
                      connectNulls={true}  // Skip points without originalValue (non-anomaly points)
                    />

                    {/* Main line for current values (either corrected or normal) */}
                    <Line
                      type="monotone"
                      dataKey={selectedMetric}
                      stroke="#000000"
                      strokeWidth={1.5}
                      dot={<CustomDotAnomaly onClick={handleAnomalyPointClick} />}
                    />

                    <Brush
                      dataKey="mTm"
                      height={40}
                      stroke="#8884d8"
                      y={280}
                      tickFormatter={(tick) => new Date(tick).toLocaleString()}
                    />
                  </LineChart>
                </ResponsiveContainer>
          </div>
          </div>
          <p style={{ margin: "2px 0", fontSize: "12px" }}>
            Click on the cell to sort it ASC
            <FaArrowUp /> or DESC
            <FaArrowDown />
          </p>
            <TableContainer
              component={Paper}
              sx={{
                backgroundColor: "#000000",
                padding: "6px",
                borderRadius: "8px",
                maxHeight: "230px",
                overflow: "auto"
              }}
            >
              <Table sx={{ minWidth: 550 }}>
                <TableHead sx={{ backgroundColor: "#ffffff" }}>
                  <TableRow>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel
                        active={sortConfig.mTm.direction !== "asc"}
                        direction={sortConfig.mTm.direction}
                        onClick={() => handleSort("mTm")}
                      >
                        Measurement Time
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel
                        active={sortConfig.wtr.direction !== "asc"}
                        direction={sortConfig.wtr.direction}
                        onClick={() => handleSort("wtr")}
                      >
                        Water Level
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel>
                        Original Value
                      </TableSortLabel>
                    </TableCell>
                    <TableCell style={{ padding: "6px 8px", fontSize: "13px" }}>
                      <TableSortLabel>
                        Is Anomaly Corrected?
                      </TableSortLabel>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sortedImDatalogs.map((datalog) => (
                    <TableRow
                      key={datalog.id}
                      sx={{
                        backgroundColor: datalog.is_anomaly_corrected
                          ? "#FF9800" // Orange if anomaly corrected
                          : "#1a1a1a", // Dark gray otherwise
                        "&:nth-of-type(odd)": {
                          backgroundColor: datalog.is_anomaly_corrected
                            ? "#FF9800" // Orange if anomaly corrected
                            : "#262626", // Slightly lighter gray otherwise
                        },
                      }}
                    >
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.mTm}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.wtr}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {/* {datalog.is_anomaly_corrected ? (
                          <span style={{ color: "#00ff00" }}>{datalog.originalValue || "N/A"}</span>
                        ) : (
                          "N/A"
                        )} */}
                        {datalog.originalValue}
                      </TableCell>
                      <TableCell sx={{ color: "#ffffff", padding: "4px 8px", fontSize: "12px" }}>
                        {datalog.is_anomaly_corrected ? "Yes" : "No"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
        </div>
        </div>
      </div>
    </div>
  );
}
export default Anomalylog;
